import { render, staticRenderFns } from "./PAF_sale.vue?vue&type=template&id=bf342812&scoped=true"
import script from "./PAF_sale.vue?vue&type=script&lang=js"
export * from "./PAF_sale.vue?vue&type=script&lang=js"
import style0 from "./PAF_sale.vue?vue&type=style&index=0&id=bf342812&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf342812",
  null
  
)

export default component.exports